import { MutationTree } from 'vuex';
import * as types from './types';
import accountState from '@account/store'
import { EnumCalendarViewType } from '@/modules/calendar/types';

import api from '../api';

import * as dateutil from '@/util/date-helper';
import lsh from '@/util/local-storage-helper';
import { dispatchEventBus } from '@/util/eventBus';

// common func
const findFolder = function (folders: calendar.Folder[], id: string): calendar.Folder | undefined {
    if (id) {
        for (let folder of folders) {
            if (folder.id === id) {
                return folder;
            } else if (folder.childFolderCount && folder.childFolderCount > 0) {
                let foundFolder = findFolder(folder.items || [], id);
                if (foundFolder) {
                    return foundFolder;
                }
            }
        }
    }
}

const findFolderAll = function (folders: any, id: string): calendar.Folder | undefined {
    let folder: calendar.Folder | undefined;
    folder = findFolder(folders.mylist.items as calendar.Folder[], id);
    if (!folder) {
        folder = findFolder(folders.companylist.items as calendar.Folder[], id);
    }

    if (!folder) {
        folder = findFolder(folders.deptlist.items as calendar.Folder[], id);
    }

    if (!folder) {
        folder = findFolder(folders.sharedlist.items as calendar.Folder[], id);
    }
    return folder;
}

// folder func
const validChecking = function (items: calendar.Folder[], savIdxArr: Array<number>): void {
    if (items) {
        for (let i = 0; i < items.length; i++) {
            if (savIdxArr.indexOf(items[i].index) != -1) {
                items[i].checked = true;
            }
        }

        if (savIdxArr.length == 0) {
            let flag: boolean = false;
            for (let item of items) {
                if (item.checked) {
                    flag = true;
                    break;
                }
            }
        }
    }
}

// folder func
const validCheckingAll = function (folders: any): void {
    if (folders) {
        let flag = false;
        let array = [
            ...folders.mylist.items, 
            ...folders.companylist.items, 
            ...folders.deptlist.items, 
            ...folders.sharedlist.items        
        ];
        for(let folder of array) {
            folder.selected = false;
            //folder.checked = true;
        }
        for (let folder of array) {
            if (folder.checked) {
                flag = true;
                break;
            }
        }
        
        if (!flag && array.length > 0) {
            array[0].checked = true;
        }
    }
}

const getContainsMonthEvents = function (idx: number, date: Date, events: ItemList<calendar.CalendarItem>): ItemList<calendar.CalendarItem> {
    let resultEvents = [];

    for (let i = 0; i < events.length; i++) {
        const event = events[i];

        var sDate = dateutil.IEDate(event.ui_month_start || event.start);
        var eDate = dateutil.IEDate(event.ui_month_end || event.end);

        if (dateutil.uGetIsInDate(date, sDate, eDate)) {
            if (!event.ui_month_jump_date || dateutil.uGetDateOnly(date) >= event.ui_month_jump_date) {
                if(event.isAllDayEvent) {
                    if(dateutil.uGetDateFormat("yyyy-MM-dd H:i:s", date) === event.end)
                        continue;                   
                }

                let newEvent: calendar.CalendarItem = Object.create(null);
                Object.assign(newEvent, event);
                newEvent.index = i;
                resultEvents.push(newEvent as calendar.CalendarItem);
            }
        }
    }
    return resultEvents;
}

const getContainsWeekEvents = function (idx: number, date: Date, events: ItemList<calendar.CalendarItem>): ItemList<calendar.CalendarItem> {
    let resultEvents = [];

    for (let i = 0; i < events.length; i++) {
        const event = events[i];

        var strDate = (event.ui_week_start || event.start) + '';

        var time = dateutil.DateAndTimeSplitor(strDate)[1];
        var tarr = time.split(':');

        var last = tarr[tarr.length - 2];

        if (!(last == '00' || last == '30')) {
            let min = Number(last);
            if (min < 30) {
                strDate = strDate.replace(time, `${tarr[0]}:00:00`);
            } else {
                strDate = strDate.replace(time, `${tarr[0]}:30:00`);
            } 
        }

        var sDate = dateutil.IEDate(strDate.split('+')[0]);

        if (sDate.getFullYear() == date.getFullYear() &&
            sDate.getMonth() == date.getMonth() &&
            sDate.getDate() == date.getDate() &&
            sDate.getHours() == date.getHours() &&
            sDate.getMinutes() == date.getMinutes()) {
            let newEvent: calendar.CalendarItem = Object.create(null);
            Object.assign(newEvent, event);
            newEvent.index = i;
            resultEvents.push(newEvent as calendar.CalendarItem);
        }
    }
    return resultEvents;
}

const getContainsWeekCalcEvents = function (date: Date, events: ItemList<calendar.CalendarItem>): ItemList<calendar.CalendarItem> {
    let resultEvents = [];

    for (let i = 0; i < events.length; i++) {
        const event = events[i];

        var sDate = dateutil.IEDate(event.ui_week_start || event.start);

        if (sDate.getFullYear() == date.getFullYear() &&
            sDate.getMonth() == date.getMonth() &&
            sDate.getDate() == date.getDate()) {
            // let newEvent: calendar.CalendarItem = Object.create(null);
            // Object.assign(newEvent, event);
            resultEvents.push(event);
        }
    }
    return resultEvents;
}

const getTargetFolderList = function (list: calendar.Folder[], target: string): calendar.Folder[] {
    let result = [];
    for (let i = 0; i < list.length; i++) {
        const folder = list[i];
        if (folder.target == target) {
            result.push(folder);
        }
    }
    return result;
}

const addPrintEvent = function(state: calendar.state.CalendarState, item: calendar.CalendarItem) {
    if (item && item.id) {
        if (!state.calendarPrintEvents) {
            state.calendarPrintEvents = [];
        }

        if (!state.calendarPrintEvents.filter((x) => x.id == item.id).length) {
            let newObj:calendar.CalendarItem = Object.create(null);
            Object.assign(newObj, item);
            state.calendarPrintEvents.push(newObj);
        }
    }
}

const buildFolderTree = function(roots: calendar.Folder[], folders: calendar.Folder[]) {
    folders.forEach(f => {
        f.target = 'VC';
        var found = roots.find(r => Number(r.id) == Number(f.parentFolderId));

        if(found) {
            if(found.items && found.childFolderCount) {
                found.items.push(f);  
                found.childFolderCount += 1;                              
            } else {
                found.items = [];                
                found.items.push(f);
                found.childFolderCount = 1;
            }
        } else {
            roots.forEach(r => {
                if(r.items) {
                    buildFolderTree(r.items, folders);
                }
            });
        }
    });
}

const getTreeFolderId = function(folders: calendar.Folder[]): number[] {
    var returnArr: number[] = [];

    folders.forEach(f => {
        returnArr.push(Number(f.id));

        if(f.items) {
            var childArr = getTreeFolderId(f.items);
            returnArr = [...returnArr, ...childArr];
        }
    });

    return returnArr;
}

export default <MutationTree<calendar.state.CalendarState>>{

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M M O N : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    [types.ADD_ACTION](state, value: types.ACTION_TYPE) {
        if (state.loadedActions.indexOf(value) == -1) {
            state.loadedActions.push(value);
        }
    },
    
    /**
     * 회의실 목록을 불러옵니다
     * @param state 
     * @param res 
     */
    [types.COMMON_ROOM_LOAD](state, res: any) {
        return api.ews_resource.getRooms().then((res) => {
            state.myRooms = res;
        }).catch((err) => {
            debugger;
        });
    },

    [types.COMMON_DATE_SELECT](state, item: calendar.DateItem) {
        Object.assign(state.backupDate, state.currentDate);
        state.currentDate = item;
        Object.assign(state.currentCalendarDate, item);
    },

    [types.COMMON_CHANGE_DATE](state, item: calendar.DateItem) {
        Object.assign(state.backupDate, state.currentDate);
        state.currentDate = item;
        Object.assign(state.currentCalendarDate, item);
    },

    // 월 선택시 
    [types.COMMON_DATE_SELECT_MONTH](state, currentDate: calendar.DateItem) {
        Object.assign(state.backupDate, state.currentDate);
        const curDateItem = currentDate;
        let newdate = dateutil.IEDate(curDateItem.date);
        let savMonth = newdate.getMonth();
        newdate.setMonth(savMonth);
        curDateItem.date = newdate;

        state.currentDate = curDateItem;
        Object.assign(state.currentCalendarDate, curDateItem);
    },

    [types.COMMON_DATE_MONTH_PREV](state, currentDate: calendar.DateItem) {
        Object.assign(state.backupDate, state.currentDate);
        const curDateItem = currentDate;
        let newdate = dateutil.IEDate(curDateItem.date);
        let savMonth = newdate.getMonth();
        newdate.setMonth(savMonth - 1);

        if (newdate.getMonth() == savMonth) // 31 지정상태에서 이전달이 30으로 끝나는 경우 변동없음 방지
        {
            newdate.setDate(0);
        }

        curDateItem.date = newdate;

        state.currentDate = curDateItem;
        Object.assign(state.currentCalendarDate, curDateItem);
    },

    [types.COMMON_DATE_MONTH_NEXT](state, currentDate: calendar.DateItem) {
        Object.assign(state.backupDate, state.currentDate);
        const curDateItem = currentDate;
        let newdate = dateutil.IEDate(curDateItem.date);
        let savMonth = newdate.getMonth();
        newdate.setMonth(savMonth + 1);

        if (Math.abs(savMonth - newdate.getMonth()) == 2) // 31지정 상태에서 다음달이 30으로 끝나는 경우 +2 된것 방지
        {
            newdate.setDate(0);
        }

        curDateItem.date = newdate;

        state.currentDate = curDateItem;
        Object.assign(state.currentCalendarDate, curDateItem);
    },

    [types.COMMON_DATE_WEEK_PREV](state, currentDate: calendar.DateItem) {
        Object.assign(state.backupDate, state.currentDate);
        const curDateItem = currentDate;
        let newdate = dateutil.IEDate(curDateItem.date);

        const sDate = dateutil.uGetWeekStartDate(newdate);
        sDate.setDate(sDate.getDate() - 1);

        curDateItem.date = sDate;
        state.currentDate = curDateItem;
        Object.assign(state.currentCalendarDate, curDateItem);
    },

    [types.COMMON_DATE_WEEK_NEXT](state, currentDate: calendar.DateItem) {
        Object.assign(state.backupDate, state.currentDate);
        const curDateItem = currentDate;
        let newdate = dateutil.IEDate(curDateItem.date);
        const eDate = dateutil.uGetWeekEndDate(newdate);

        eDate.setDate(eDate.getDate() + 1);
        curDateItem.date = eDate;

        curDateItem.date = eDate;
        state.currentDate = curDateItem;
        Object.assign(state.currentCalendarDate, curDateItem);
    },

    [types.COMMON_DATE_DATE_PREV](state, currentDate: calendar.DateItem) {
        Object.assign(state.backupDate, state.currentDate);
        const curDateItem = currentDate;
        let newdate = dateutil.IEDate(curDateItem.date);
        newdate.setDate(newdate.getDate() - 1);

        curDateItem.date = newdate;
        state.currentDate = curDateItem;
        Object.assign(state.currentCalendarDate, curDateItem);
    },

    [types.COMMON_DATE_DATE_NEXT](state, currentDate: calendar.DateItem) {
        Object.assign(state.backupDate, state.currentDate);
        const curDateItem = currentDate;
        let newdate = dateutil.IEDate(curDateItem.date);
        newdate.setDate(newdate.getDate() + 1);

        curDateItem.date = newdate;
        state.currentDate = curDateItem;
        Object.assign(state.currentCalendarDate, curDateItem);
    },

    // 현재 사용자 정보 가져오기
    [types.COMMON_CURRNT_USER](state, user: account.User) {
        //return accountState.state.user;
        return ''
    },

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: F O L D E R : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    [types.FOLDER_SELECT](state, item: calendar.Folder) {
        item.checked = !item.checked;
        
        let listStr: 'mylist' | 'companylist' | 'deptlist' | 'sharedlist' = 'mylist';

        if (item.dbType == 'CM') {
            listStr = 'companylist';
        }

        if (item.dbType == 'DC') {
            listStr = 'deptlist';
        }

        if (item.target == 'SHARE') {
            listStr = 'sharedlist';
        }

        var arrIdx = state.folders[listStr].checkedIdxArray.indexOf(item.index);
        if (item.checked) {
            if (arrIdx == -1) {
                state.folders[listStr].checkedIdxArray.push(item.index);
            }
        } else {
            if (arrIdx != -1) {
                state.folders[listStr].checkedIdxArray.splice(arrIdx, 1);
            }
        }

        validChecking(state.folders[listStr].items, state.folders[listStr].checkedIdxArray);
        validCheckingAll(state.folders);
        item.selected = true;
        state.folders.currentFolder = item;        
        if(state.folders.currentFolder.isEWS){
            state.toolbar.folderShare.FolderID = item.id;            
            state.toolbar.folderShare.FolderName = item.displayName;
        }
        state.toolbar.folderShare.SharedList = [];

        let chkArray = [state.folders.mylist.checkedIdxArray,
            state.folders.companylist.checkedIdxArray,  
            state.folders.deptlist.checkedIdxArray, 
            state.folders.sharedlist.checkedIdxArray];

        if(accountState.state.current?.user != null) {
            lsh.set(types.FOLDER_SELECT + accountState.state.current.user.personCode, chkArray);
        }         
    },

    [types.FOLDER_EDIT_NAME](state, data: { id: string, displayName: string }) {
        const { id, displayName } = data;
        const folder = findFolderAll(state.folders, id);
        if (folder) {
            folder.displayName = displayName;
        }
    },

    [types.FOLDER_EDIT_COLOR](state, data: { id: string, colorCode: string }) {
        const { id, colorCode } = data;
        const folder = findFolderAll(state.folders, id);
        if (folder) {
            folder.colorCode = colorCode;
        }
    },

    [types.FOLDER_LOAD_TREE](state: any, data: { items: calendar.Folder[], parentId?: string }) {
        console.log('FolderLoadTree')
        let mylist: calendar.Folder[] = [];
        let companylist: calendar.Folder[] = [];
        let deptlist: calendar.Folder[] = [];
        let sharedlist: calendar.Folder[] = [];

        for (let i = 0; i < data.items.length; i++) {
            const item = data.items[i];
            if (item.isEWS) {
                if (item.isShared) {
                    item.target = 'SHARE';
                    sharedlist.push(item);
                } else {
                    item.target = 'MY';
                    mylist.push(item);
                }
            } else {
                if (item.dbType == 'CM') {
                    item.target = 'CM';
                    companylist.push(item);
                }

                if (item.dbType == 'DC') {
                    deptlist.push(item);
                }                
            }
        }      
        
        var personCode = accountState.state.current?.user == null ? '' : accountState.state.current.user.personCode;
        let chkArray = lsh.get(types.FOLDER_SELECT + personCode);

        const id = data.parentId || '';
        const myfolder = findFolder(state.folders.mylist.items, id);
        if (myfolder) {
            myfolder.items = mylist;
        } else {
            state.folders.mylist.items = mylist;
        }

        if (chkArray && chkArray.length) {
            state.folders.mylist.checkedIdxArray = chkArray[0];
        }

        validChecking(state.folders.mylist.items, state.folders.mylist.checkedIdxArray);

        
        state.folders.sharedlist.items = sharedlist;      
        if (chkArray && chkArray.length) {
            state.folders.sharedlist.checkedIdxArray = chkArray[3];
        }  
        validChecking(state.folders.sharedlist.items, state.folders.sharedlist.checkedIdxArray);

        if (!state.toolbar.search.ParentFolderID && mylist.length) {
            state.toolbar.search.ParentFolderID = mylist[0].id;
        }

        if (state.folders.mylist.items.length) {
            state.folders.currentFolder = state.folders.mylist.items[0];
        }

        const companyfolder = findFolder(state.folders.companylist.items, id);
        if (companyfolder) {
            companyfolder.items = companylist;
        } else {
            state.folders.companylist.items = companylist;
        }
        if (chkArray && chkArray.length) {
            state.folders.companylist.checkedIdxArray = chkArray[1];
        }
        validChecking(state.folders.companylist.items, state.folders.companylist.checkedIdxArray);

        const deptfolder = findFolder(state.folders.deptlist.items, id);
        if (deptfolder) {
            deptfolder.items = deptlist;
        } else {
            state.folders.deptlist.items = deptlist;
        }
        if (chkArray && chkArray.length) {
            state.folders.deptlist.checkedIdxArray = chkArray[2];
        }
        validChecking(state.folders.deptlist.items, state.folders.deptlist.checkedIdxArray);

        validCheckingAll(state.folders);
        dispatchEventBus(window, 'calendar-folder-loaded', null);
    },

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C A L E N D A R : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //
    [types.CALENDAR_CURRENT_APPOINTMENT](state, item: any){
        state.setAppointment = item;
    },

    [types.CURRENT_CALENDAR_ITEM](state, item: calendar.CalendarItem) {
        state.currentCalendarItem = item;
//         state.currentCalendarItem = {
//             ...state.currentCalendarItem,
//             ...item
//         };
    },

    [types.CALENDAR_HIDE_SHOW](state) {
        state.calendarHideShow = !state.calendarHideShow;
    },

    [types.CALENDAR_DATE_SELECT](state, item: calendar.DateItem) {
        //Object.assign(state.backupDate, state.currentDate);
        state.currentCalendarDate = item;
    },

    [types.CALENDAR_DATETIME_SELECT](state, item: calendar.DateItem) {
        //Object.assign(state.backupDate, state.currentDate);
        state.currentCalendarTime = item;
    },

    [types.CALENDAR_EVENT_SELECT_ID](state, eventId: string) {
        state.calendarSelectedEventID = eventId;
    },

    //3번
    [types.CALENDAR_MONTH_MATRIX_LOAD](state) {
        state.calendarMonthMatrix = [];

        let copyEvents = [] as ItemList<calendar.CalendarItem>;
        let allEvents = [] as ItemList<calendar.CalendarItem>;
        const limitCount = 3;

        let current_h_idx_flags = [] as Array<Date>;
        Object.assign(copyEvents, state.calendarEvents);   

        const sortFn = function (a: any, b: any): number {
            return a == b ? 0 : a < b ? -1 : 1;
        }

        //원본이벤트를 뷰에 보여지는 용도로 정렬 후 Copy
        copyEvents.sort((a, b) =>
            sortFn(
                Number(dateutil.IEDate(b.ui_month_end || b.end)) - Number(dateutil.IEDate(b.ui_month_start || b.start)),
                Number(dateutil.IEDate(a.ui_month_end || a.end)) - Number(dateutil.IEDate(a.ui_month_start || a.start)))
            || sortFn(Number(dateutil.IEDate(a.ui_month_start || a.start)), Number(dateutil.IEDate(b.ui_month_start || b.start)))
            || sortFn(Number(a.dateTimeCreated), Number(b.dateTimeCreated))
        );


        //Month View가 아닐 경우 계산
        Object.assign(allEvents, state.calendarEvents);
        if (state.calendarMode != EnumCalendarViewType.Month) {
            for (let i = 0; i < copyEvents.length; i++) {
                const event = copyEvents[i];
                let removeFlag = false;
                let IsAtLeastOneDate = false;
                if (event.scheduleDuration) {
                    let dayCount = Number(event.scheduleDuration.split('.')[0]);
                    if (dayCount == 0 || isNaN(dayCount)) {
                        removeFlag = true;
                    } else {
                        IsAtLeastOneDate = true;
                    }
                }
                if (!IsAtLeastOneDate) {
                    if ((event.isAllDayEvent as any) == 'False' || event.isAllDayEvent == false) {
                        removeFlag = true;
                    }
                }

                // let weekStart = dateutil.uGetDateOnly(dateutil.uGetWeekStartDate(state.currentDate.date));
                // let weekEnd = dateutil.uGetDateOnly(dateutil.uGetWeekEndDate(state.currentDate.date));

                // let eventStart = dateutil.uGetDateOnly(dateutil.IEDate(event.start));
                // let eventEnd = dateutil.uGetDateOnly(dateutil.IEDate(event.end));
                // let inWeeks = eventStart >= weekStart && eventStart <= weekEnd &&
                //     eventEnd >= weekStart && eventEnd <= weekEnd;
                if (removeFlag) {
                    copyEvents.splice(i, 1);
                    i--;
                }
            }
        }

        let matrix = [] as Array<Array<calendar.DateItem>>;
        let Rows = [];
        let today = new Date();
        let daysList = [] as Date[];

        //뷰에 따라서 날짜 범위계산에서 값 카피
        if (state.calendarMode == EnumCalendarViewType.Month) {
            daysList = dateutil.uGetDaysInMonth(state.monthDate, true, 0);
        }
        else if (state.calendarMode == EnumCalendarViewType.Week) {
            //debugger;
            daysList = dateutil.uGetDaysInWeek(state.currentDate.date, 0);
        } else if (state.calendarMode == EnumCalendarViewType.Daily) {
            for (let di = 0; di < 7; di++) {
                daysList.push(dateutil.uGetDateOnly(state.currentDate.date));                
            }
        }

        //필터조건으로 시작날짜, 종료날짜 설정
        for (let i = 0; i < copyEvents.length; i++) {
            const event = copyEvents[i];
            if (dateutil.IEDate(event.start) < daysList[0]) {
                event.ui_month_start = dateutil.uGetDateFormat('yyyy-MM-DD', daysList[0]) + ' ' + dateutil.uGetDateFormat('H:i:s', dateutil.IEDate(event.start));
            }

            if (dateutil.IEDate(event.end) > daysList[daysList.length - 1]) {
                event.ui_month_end = dateutil.uGetDateFormat('yyyy-MM-DD', daysList[daysList.length - 1]) + ' ' + dateutil.uGetDateFormat('H:i:s', dateutil.IEDate(event.end));
            }
        }


        for (let i = 0; i < daysList.length; i++) {
            let date = daysList[i];
            let isWeekStart = dateutil.uGetWeekStartDate(date, 0 || 0).getDate() == date.getDate();

            if (isWeekStart) {
                for (let f = 0; f < limitCount; f++) {
                    current_h_idx_flags[f] = dateutil.IEDate(0);
                }
            }            

            let isToday =
                date.getFullYear() == today.getFullYear() &&
                date.getMonth() == today.getMonth() &&
                date.getDate() == today.getDate();

            let isSelected =
                date.getFullYear() == state.currentCalendarDate.date.getFullYear() &&
                date.getMonth() == state.currentCalendarDate.date.getMonth() &&
                date.getDate() == state.currentCalendarDate.date.getDate();

            let isDisplayArea = false;
            if (state.calendarMode == EnumCalendarViewType.Month) {
                if (state.currentCalendarDate.date.getMonth() == date.getMonth()) {
                    isDisplayArea = true;
                }
            }

            if (state.calendarMode == EnumCalendarViewType.Week) {
                let weekStartDate = dateutil.uGetWeekStartDate(state.currentCalendarDate.date, 0);
                let weekEndDate = dateutil.uGetWeekEndDate(state.currentCalendarDate.date, 0);

                if (Number(weekStartDate) <= Number(date) && Number(weekEndDate) >= Number(date)) {
                    isDisplayArea = true;
                }
            }

            if (state.calendarMode == EnumCalendarViewType.Daily) {
                if (isSelected) {
                    isDisplayArea = true;
                }
            }           

            let curEvents = getContainsMonthEvents(i, date, copyEvents);            
            let curAllEvents = state.calendarMode == EnumCalendarViewType.Month ? getContainsMonthEvents(i, date, allEvents) : [];            

            let limitedEvents = curEvents.map((item, index) => {
                if (index < limitCount) {
                    return item;
                }
            }) as ItemList<calendar.CalendarItem>;

            for (let l = 0; l < limitedEvents.length; l++) {
                const litem = limitedEvents[l];

                if (litem == undefined) {
                    limitedEvents.splice(l, 1);
                    l--;
                    continue;
                }

                litem.ui_month_hindex = l;

                //반복일정하나를 보여주기위해 여러개 복사
                if (!litem.ui_copyed) {

                    let sdate = dateutil.uGetDateOnly(dateutil.IEDate(litem.ui_month_start || litem.start));
                    let realEndDateTime = dateutil.IEDate(litem.end);
                    let realAndDateOnly = dateutil.uGetDateOnly(realEndDateTime);
                    let edate = dateutil.uGetDateOnly(dateutil.IEDate(litem.ui_month_end || litem.end));

                    let isEndZero = realEndDateTime.getHours() == 0 && realEndDateTime.getMinutes() == 0;

                    if (isEndZero &&
                        dateutil.uGetDateOnly(daysList[0]) <= realAndDateOnly &&
                        dateutil.uGetDateOnly(daysList[daysList.length - 1]) >= realAndDateOnly) {
                        edate.setDate(edate.getDate() - 1);
                    }

                    let expTimes = (Number(edate) - Number(sdate));
                    let totalDays = Math.round(expTimes / (1000 * 60 * 60 * 24)) + 1;
                    litem.ui_month_width_count = totalDays;
                    let dayGap = 7;
                    
                    let calcDay = (date.getDay() + dayGap) % 7;
                    let copyCount = Math.floor((calcDay + totalDays - 1) / 7);

                    if (copyCount > 0) {
                        litem.ui_month_width_count = 7 - calcDay;
                    }
                    let savWCount = litem.ui_month_width_count;

                    for (let c = 0; c < copyCount; c++) {
                        let copyItem: calendar.CalendarItem = Object.create(null);
                        Object.assign(copyItem, litem);
                        let cDate = dateutil.IEDate(date);
                        cDate.setDate(cDate.getDate() + 7 * (c + 1));
                        copyItem.ui_month_jump_date = dateutil.uGetDateOnly(dateutil.uGetWeekStartDate(cDate, 0));
                        if (c == 0) {
                            copyItem.ui_month_width_count = copyCount == 1 ? (totalDays - litem.ui_month_width_count) : 7;
                            savWCount += copyItem.ui_month_width_count;
                        }
                        else if (c < copyCount - 1) {
                            copyItem.ui_month_width_count = 7;
                            savWCount += copyItem.ui_month_width_count;
                        }
                        else {
                            copyItem.ui_month_width_count = (totalDays - savWCount) > 7 ? 7 : (totalDays - savWCount);
                        }
                        copyItem.ui_copyed = true;
                        if (state.calendarMode != EnumCalendarViewType.Month) {
                            copyItem.ui_month_in_week = true;
                        }
                        copyEvents.push(copyItem);
                    }
                }
            }            

            limitedEvents.sort((a, b) => 
                sortFn(
                    Number(dateutil.IEDate(b.ui_month_end || b.end)) - Number(dateutil.IEDate(b.ui_month_start || b.start)), 
                    Number(dateutil.IEDate(a.ui_month_end || a.end)) - Number(dateutil.IEDate(a.ui_month_start || a.start)))
                || sortFn(Number(dateutil.IEDate(a.ui_month_start || a.start)), Number(dateutil.IEDate(b.ui_month_start || b.start)))
                || sortFn(Number(a.dateTimeCreated), Number(b.dateTimeCreated)) 
            );

            let resultArray = [] as ItemList<calendar.CalendarItem>;
            let flagIdx = 0;
            let addedCount = 0;

            for (let l = 0; flagIdx < limitCount; l++) {
                const litem = limitedEvents[l];

                if (current_h_idx_flags[flagIdx] >= dateutil.uGetDateOnly(date) || !litem) {
                    resultArray.push({
                        id: 'null',
                        color: 'null',
                        start: '',
                        ui_month_hindex: flagIdx,
                        ui_month_width_count: 1,
                    } as calendar.CalendarItem);
                    l--;
                    addedCount++;
                } else {
                    if (litem) {
                        litem.ui_month_hindex = flagIdx;
                        addPrintEvent(state, litem);
                        resultArray.push(litem);

                        if (litem.ui_month_width_count > 1) {
                            let idxDate = dateutil.uGetDateOnly(dateutil.IEDate(litem.ui_month_end || litem.end));
                            if (current_h_idx_flags[flagIdx] < idxDate) {     
                                let ridxDate = dateutil.IEDate(litem.ui_month_end || litem.end); 
                                if (ridxDate.getHours() == 0 && ridxDate.getMinutes() == 0 && ridxDate.getSeconds() == 0) {
                                    idxDate.setSeconds(idxDate.getSeconds() - 1);
                                }
                                current_h_idx_flags[flagIdx] = idxDate;
                            }
                        }
                    }

                    if (flagIdx == 2 && dateutil.uGetDateOnly(date) > current_h_idx_flags[flagIdx]) {
                        current_h_idx_flags[flagIdx] = dateutil.IEDate(0);
                    }
                }

                flagIdx++;
            }

            let moreCount = curEvents.length + addedCount;

            if (state.calendarMode == EnumCalendarViewType.Month) {                
                moreCount = curAllEvents.length;
            } 

            for (let e = 0; e < curEvents.length; e++) {
                const event = curEvents[e];
                copyEvents.splice(event.index - e, 1);
            }

            let dateItem = {
                date: date,
                isToday: isToday,
                isSelected: isSelected,
                isSun: date.getDay() == 0,
                isSat: date.getDay() == 6,
                isDisplayArea: isDisplayArea,
                MoreEventsCount: moreCount > limitCount ? moreCount - limitCount : 0,
                events: resultArray,
            } as calendar.DateItem;

            Rows.push(dateItem);

            if ((i + 1) % 7 == 0) {
                let NewRows = new Array;
                NewRows = Object.assign(NewRows, Rows);
                matrix.push(NewRows);
                Rows = [];
            }
        }
        state.calendarMonthMatrix = matrix;
    },

    [types.CALENDAR_WEEK_MATRIX_LOAD](state) {
        state.calendarWeekMatrix = [];
        
        let copyEvents = [] as ItemList<calendar.CalendarItem>;

        Object.assign(copyEvents, state.calendarEvents);

        if (state.calendarMode == EnumCalendarViewType.Week) {
            for (let i = 0; i < copyEvents.length; i++) {
                const event = copyEvents[i];
                let removeFlag = false;
                if (event.scheduleDuration) {
                    let dayCount = Number(event.scheduleDuration.split('.')[0]);
                    if (dayCount > 0 && !isNaN(dayCount)) {
                        removeFlag = true;
                    }
                }

                if ((event.isAllDayEvent as any) == 'True' || event.isAllDayEvent == true) {
                    removeFlag = true;
                }

                // let weekStart = dateutil.uGetDateOnly(dateutil.uGetWeekStartDate(state.currentDate.date));
                // let weekEnd = dateutil.uGetDateOnly(dateutil.uGetWeekEndDate(state.currentDate.date));

                // let eventStart = dateutil.uGetDateOnly(dateutil.IEDate(event.start));
                // let eventEnd = dateutil.uGetDateOnly(dateutil.IEDate(event.end));
                // let inWeeks = eventStart >= weekStart && eventStart <= weekEnd &&
                //     eventEnd >= weekStart && eventEnd <= weekEnd;
                // if (event.isRecurring) {
                //     removeFlag = false;
                // }

                if (removeFlag) {
                    copyEvents.splice(i, 1);
                    i--;
                }
            }
        }

        for (let c = 0; c < copyEvents.length; c++) {
            const event = copyEvents[c];
            if (!event.ui_copyed) {
                let cStart = dateutil.uGetDateOnly(dateutil.IEDate(event.start));
                let cEnd = dateutil.uGetDateOnly(dateutil.IEDate(event.end));

                 if (cStart.toString() != cEnd.toString()) {
                    let copyItem: calendar.CalendarItem = Object.create(null);
                    event.ui_week_start = dateutil.uGetDateFormat('yyyy-MM-DD H:i:00', dateutil.IEDate(event.start));
                    event.ui_week_end = dateutil.uGetDateFormat('yyyy-MM-DD 00:00:00', cEnd);
                    Object.assign(copyItem, event);

                    copyItem.ui_week_start = dateutil.uGetDateFormat('yyyy-MM-DD 00:00:00', cEnd);
                    copyItem.ui_week_end = dateutil.uGetDateFormat('yyyy-MM-DD H:i:00', dateutil.IEDate(event.end));
                    copyItem.ui_copyed = true;

                    copyEvents.push(copyItem);
                }
            }
        }

        const sortFn = function (a: any, b: any): number {
            return a == b ? 0 : a < b ? -1 : 1;
        }

        let matrix = [] as Array<Array<calendar.DateItem>>;
        let today = new Date();
        let daysList = dateutil.uGetDaysInWeek(state.currentDate.date);
        // debugger;
        let daysEventList = [];
        let timeList = dateutil.uGetTimeArray();
        let valueList = timeList.map((x) => x.value);
        valueList.push('24:00:00');
        for (let i = 0; i < daysList.length; i++) {
            const oDate = daysList[i];
            let date = new Date(oDate);
            let calcEvents = getContainsWeekCalcEvents(date, copyEvents);

            calcEvents.sort((a, b) =>
                sortFn(Number(dateutil.IEDate(a.ui_week_start || a.start)), Number(dateutil.IEDate(b.ui_week_start || b.start))) ||
                sortFn(Number(a.dateTimeCreated), Number(b.dateTimeCreated))
            );
            daysEventList[i] = calcEvents;
        }

        let timevalue = 0;
        let tidx = 0;
        let duplicateCheckArray: Array<Array<number>> = [];
        for (const timeItem of timeList) {
            for (let i = 0; i < daysList.length; i++) {
                const oDate = daysList[i];
                let eventArr = daysEventList[i];
                let date = new Date(oDate);
                date = new Date(dateutil.uGetDateFormat('yyyy-MM-DD', date) + 'T' + timeItem.value); // Set Time
                if (!duplicateCheckArray[i]) {
                    duplicateCheckArray[i] = [];
                }

                if (!duplicateCheckArray[i][tidx]) {
                    duplicateCheckArray[i][tidx] = 0;
                }

                for (let d = 0; d < eventArr.length; d++) {
                    const event = eventArr[d];

                    let date30m = dateutil.IEDate(date);
                    date30m.setMinutes(date30m.getMinutes() + 30);
                    if (dateutil.uGetInDateBoundary(date, date30m,
                        dateutil.IEDate(event.ui_week_start || event.start),
                        dateutil.IEDate(event.ui_week_end || event.end))) {
                        duplicateCheckArray[i][tidx]++;
                    }
                }

            }
            tidx++;
        }

        for (let i = 0; i < daysList.length; i++) {
            const oDate = daysList[i];
            for (let t = 0; t < daysEventList[i].length; t++) {
                const event = daysEventList[i][t];
                let sDate = dateutil.IEDate(event.ui_week_start || event.start);
                let eDate = dateutil.IEDate(event.ui_week_end || event.end);

                let TotalMins = dateutil.uGetTotalDiffMinutes(sDate, eDate);
                event.ui_week_height_count = Math.round(TotalMins / 30);

                if (event.ui_week_height_count <= 0) {
                    event.ui_week_height_count = 1;
                }

                let svalue = dateutil.DateAndTimeSplitor((event.ui_week_start || event.start))[1];
                let evalue = dateutil.DateAndTimeSplitor((event.ui_week_end || event.end))[1];

                const virtualTime = (time: string) => {
                    var tarr = time.split(':');
                    var last = tarr[tarr.length - 2];
                    if (!(last == '00' || last == '30')) {
                        let min = Number(last);
                        if (min < 30) {
                            return `${tarr[0]}:00:00`;
                        } else {
                            return `${tarr[0]}:30:00`;
                        } 
                    }
                    return time;
                }

                let Vsvalue = virtualTime(svalue);
                let Vevalue = virtualTime(evalue);                

                let sidx = valueList.indexOf(Vsvalue);
                let eidx = valueList.indexOf(Vevalue);

                if (sDate.getDate() != eDate.getDate() && evalue == '00:00:00') {
                    eidx = valueList.indexOf('24:00:00');
                }

                let max = 0;
                for (let dp = sidx; dp <= eidx; dp++) {
                    let num = duplicateCheckArray[i][dp];
                    if (max < num) {
                        max = num;
                    }
                }
                event.ui_week_maxcount = max;
            }            

            for (let x = 0; x < daysEventList[i].length; x++) {
                const source = daysEventList[i][x];
                let smax = source.ui_week_maxcount;
                for (let y = 0; y < daysEventList[i].length; y++) {
                    const target = daysEventList[i][y];
                    if (x != y) {
                        if (dateutil.uGetInDateBoundary(
                            dateutil.IEDate(source.ui_week_start || source.start),
                            dateutil.IEDate(source.ui_week_end || source.end),
                            dateutil.IEDate(target.ui_week_start || target.start),
                            dateutil.IEDate(target.ui_week_end || target.end))) {
                            if (smax < target.ui_week_maxcount) {
                                source.ui_week_maxcount = target.ui_week_maxcount;
                            }
                        }
                    }
                }
            }
            
            let saveIndexArray:Array<Array<calendar.CalendarItem>> = [];
            
            for (let x = 0; x < daysEventList[i].length; x++) {
                const source = daysEventList[i][x];
                let calcIdx = 0;
                for (let y = 0; y < x; y++) {
                    let sStartNum = Number(dateutil.IEDate(source.ui_week_start || source.start));
                    if (saveIndexArray[y]) {
                        for (let s = 0; s < saveIndexArray[y].length; s++) {
                            const sevent = saveIndexArray[y][s];
                            let bStartNum = Number(dateutil.IEDate(sevent.ui_week_start || sevent.start));
                            let bEndNum = Number(dateutil.IEDate(sevent.ui_week_end || sevent.end));
                            if (sStartNum >= bStartNum && sStartNum < bEndNum) {
                                calcIdx++;
                            } 
                        }

                        if (calcIdx == y) {
                            break;
                        }
                    }                    
                }
                if (!saveIndexArray[calcIdx]) 
                {
                    saveIndexArray[calcIdx] = [];
                }                
                
                source.ui_week_ui_index = calcIdx;

                saveIndexArray[calcIdx].push(source);
            }            
        }

        let limitCount = 9;
        for (let x = 0; x < copyEvents.length; x++) {
            const event = copyEvents[x];
            if (event.ui_week_maxcount > limitCount) {
                event.ui_week_maxcount = limitCount;
            }

            if (event.ui_week_ui_index >= limitCount) {
                copyEvents.splice(x, 1);
                x--;
            }
        }

        tidx = 0;

        for (const timeItem of timeList) {
            if (tidx > 48) break;
            let Rows = [];
            let titleDateItem: calendar.DateItem = Object.create(null);
            titleDateItem.ui_days_week_time_text = dateutil.uGetZero(timevalue) as string;
            Rows.push(titleDateItem);
            for (let i = 0; i < daysList.length; i++) {
                let oDate = daysList[i];
                let date = new Date(oDate);
                date = new Date(dateutil.uGetDateFormat('yyyy-MM-DD', date) + 'T' + timeItem.value); // Set Time

                let isToday =
                    date.getFullYear() == today.getFullYear() &&
                    date.getMonth() == today.getMonth() &&
                    date.getDate() == today.getDate();

                let isSelected =
                    date.getFullYear() == state.currentCalendarTime.date.getFullYear() &&
                    date.getMonth() == state.currentCalendarTime.date.getMonth() &&
                    date.getDate() == state.currentCalendarTime.date.getDate() &&
                    date.getHours() == state.currentCalendarTime.date.getHours() &&
                    date.getMinutes() == state.currentCalendarTime.date.getMinutes();

                let isDisplayArea = false;
                if (state.calendarMode == EnumCalendarViewType.Month) {
                    if (state.currentCalendarDate.date.getMonth() == date.getMonth()) {
                        isDisplayArea = true;
                    }
                }

                if (state.calendarMode == EnumCalendarViewType.Week) {
                    let weekStartDate = dateutil.uGetWeekStartDate(state.currentCalendarDate.date );
                    let weekEndDate = dateutil.uGetWeekEndDate(state.currentCalendarDate.date);

                    if (Number(weekStartDate) <= Number(date) && Number(weekEndDate) >= Number(date)) {
                        isDisplayArea = true;
                    }
                }

                if (state.calendarMode == EnumCalendarViewType.Daily) {
                    if (isSelected) {
                        isDisplayArea = true;
                    }
                }

                let curEvents = getContainsWeekEvents(i, date, copyEvents);
                
                for (let e = 0; e < curEvents.length; e++) {
                    const event = curEvents[e];
                    copyEvents.splice(event.index - e, 1);
                }

                let max = 0;
                for (let t = 0; t < curEvents.length; t++) {
                    const event = curEvents[t];
                    max = event.ui_week_maxcount;
                }

                let resultEvents = [];

                for (let c = 0; c < max; c++) {
                    let isAddedFlag = false;
                    for (let f = 0; f < curEvents.length; f++) {
                        const fevent = curEvents[f];
                        if (fevent.ui_week_ui_index == c) {
                            let copyEvent: calendar.CalendarItem = Object.create(null);
                            Object.assign(copyEvent, fevent);
                            addPrintEvent(state, copyEvent);
                            resultEvents.push(copyEvent);
                            isAddedFlag = true;
                            break;
                        }
                    }

                    if (!isAddedFlag) {
                        resultEvents.push({
                            id: 'null',
                            color: 'null',
                            organizer: {
                                name: null,
                            },
                        });
                    }
                }

                let dateItem = {
                    date: date,
                    isToday: isToday,
                    isSelected: isSelected,
                    isSun: date.getDay() == 0,
                    isSat: date.getDay() == 6,
                    isDisplayArea: isDisplayArea,
                    events: resultEvents,
                } as calendar.DateItem;

                Rows.push(dateItem);
            }
            let NewRows = new Array;
            NewRows = Object.assign(NewRows, Rows);
        
            matrix.push(NewRows);

            timevalue += 0.5;
            tidx++;
        }

        /** 
         * 20201230 수정
         */
        let newMat = [] as any;
        for(let i=0; i<48; i++) {
            for(let j=0; j<8; j++) {
                if (!newMat[j]) {
                    newMat[j] = [];
                }
                newMat[j][i] = matrix[i][j];
            }
        }
        newMat = newMat.slice(1,8);
        
        /**
         * 원래 Matrix (모바일 주별보기에서 하루씩 더 앞으로 그려짐)
         */
        // let newMat = [] as any;
        // for(let i=0; i<48; i++) {
        //     for(let j=0; j<7; j++) {
        //         if (!newMat[j]) {
        //             newMat[j] = [];
        //         }
        //         newMat[j][i] = matrix[i][j];
        //     }
        // }
        
        state.calendarWeekMatrix = newMat;
    },

    [types.CALENDAR_DATE_MATRIX_LOAD](state) {


        state.calendarDateMatrix = [];

        let copyEvents = [] as ItemList<calendar.CalendarItem>;

        Object.assign(copyEvents, state.calendarEvents);
        
        if (state.calendarMode == EnumCalendarViewType.Daily) {
            for (let i = 0; i < copyEvents.length; i++) {
                const event = copyEvents[i];
                let removeFlag = false;
                if (event.scheduleDuration) {
                    let dayCount = Number(event.scheduleDuration.split('.')[0]);
                    if (dayCount > 0 && !isNaN(dayCount)) {
                        removeFlag = true;
                    }
                }

                if ((event.isAllDayEvent as any) == 'True' || event.isAllDayEvent == true) {
                    removeFlag = true;
                }

                // if (event.isRecurring) {
                //     removeFlag = false;
                // }

                // let weekStart = dateutil.uGetDateOnly(dateutil.uGetWeekStartDate(state.currentDate.date));
                // let weekEnd = dateutil.uGetDateOnly(dateutil.uGetWeekEndDate(state.currentDate.date));

                // let eventStart = dateutil.uGetDateOnly(dateutil.IEDate(event.start));
                // let eventEnd = dateutil.uGetDateOnly(dateutil.IEDate(event.end));
                // let inWeeks = eventStart >= weekStart && eventStart <= weekEnd &&
                //     eventEnd >= weekStart && eventEnd <= weekEnd;
                if (removeFlag) {
                    copyEvents.splice(i, 1);
                    i--;
                }
            }
        }
        
        for (let c = 0; c < copyEvents.length; c++) {
            const event = copyEvents[c];
            if (!event.ui_copyed) {
                let cStart = dateutil.uGetDateOnly(dateutil.IEDate(event.start));
                let cEnd = dateutil.uGetDateOnly(dateutil.IEDate(event.end));

                if (cStart.toString() != cEnd.toString()) {
                    let copyItem: calendar.CalendarItem = Object.create(null);
                    event.ui_week_start = dateutil.uGetDateFormat('yyyy-MM-DD H:i:00', dateutil.IEDate(event.start));
                    event.ui_week_end = dateutil.uGetDateFormat('yyyy-MM-DD 00:00:00', cEnd);
                    Object.assign(copyItem, event);

                    copyItem.ui_week_start = dateutil.uGetDateFormat('yyyy-MM-DD 00:00:00', cEnd);
                    copyItem.ui_week_end = dateutil.uGetDateFormat('yyyy-MM-DD H:i:00', dateutil.IEDate(event.end));
                    copyItem.ui_copyed = true;

                    copyEvents.push(copyItem);
                }
            }
        }

        const sortFn = function (a: any, b: any): number {
            return a == b ? 0 : a < b ? -1 : 1;
        }

        let matrix = [] as Array<Array<calendar.DateItem>>;
        let today = new Date();
        let daysList = [dateutil.uGetDateOnly(state.currentDate.date)]; //dateutil.uGetDaysInWeek(state.currentDate.date);
        let daysEventList = [];
        let timeList = dateutil.uGetTimeArray();
        let valueList = timeList.map((x) => x.value);
        valueList.push('24:00:00');
        for (let i = 0; i < daysList.length; i++) {
            const oDate = daysList[i];
            let date = new Date(oDate);
            let calcEvents = getContainsWeekCalcEvents(date, copyEvents);

            calcEvents.sort((a, b) =>
                sortFn(Number(dateutil.IEDate(a.ui_week_start || a.start)), Number(dateutil.IEDate(b.ui_week_start || b.start))) ||
                sortFn(Number(a.dateTimeCreated), Number(b.dateTimeCreated))
            );
            daysEventList[i] = calcEvents;
        }

        let timevalue = 0;
        let tidx = 0;
        let duplicateCheckArray: Array<Array<number>> = [];
        for (const timeItem of timeList) {
            for (let i = 0; i < daysList.length; i++) {
                const oDate = daysList[i];
                let eventArr = daysEventList[i];
                let date = new Date(oDate);
                date = new Date(dateutil.uGetDateFormat('yyyy-MM-DD', date) + 'T' + timeItem.value); // Set Time
                if (!duplicateCheckArray[i]) {
                    duplicateCheckArray[i] = [];
                }

                if (!duplicateCheckArray[i][tidx]) {
                    duplicateCheckArray[i][tidx] = 0;
                }

                for (let d = 0; d < eventArr.length; d++) {
                    const event = eventArr[d];

                    let date30m = dateutil.IEDate(date);
                    date30m.setMinutes(date30m.getMinutes() + 30);
                    if (dateutil.uGetInDateBoundary(date, date30m,
                        dateutil.IEDate(event.ui_week_start || event.start),
                        dateutil.IEDate(event.ui_week_end || event.end))) {
                        duplicateCheckArray[i][tidx]++;
                    }
                }

            }
            tidx++;
        }

        for (let i = 0; i < daysList.length; i++) {
            const oDate = daysList[i];
            for (let t = 0; t < daysEventList[i].length; t++) {
                const event = daysEventList[i][t];
                let sDate = dateutil.IEDate(event.ui_week_start || event.start);
                let eDate = dateutil.IEDate(event.ui_week_end || event.end);

                let TotalMins = dateutil.uGetTotalDiffMinutes(sDate, eDate);
                event.ui_week_height_count = Math.round(TotalMins / 30);

                if (event.ui_week_height_count <= 0) {
                    event.ui_week_height_count = 1;
                }

                let svalue = dateutil.DateAndTimeSplitor((event.ui_week_start || event.start))[1];
                let evalue = dateutil.DateAndTimeSplitor((event.ui_week_end || event.end))[1];

                const virtualTime = (time: string) => {
                    var tarr = time.split(':');
                    var last = tarr[tarr.length - 2];
                    if (!(last == '00' || last == '30')) {
                        let min = Number(last);
                        if (min < 30) {
                            return `${tarr[0]}:00:00`;
                        } else {
                            return `${tarr[0]}:30:00`;
                        } 
                    }
                    return time;
                }

                let Vsvalue = virtualTime(svalue);
                let Vevalue = virtualTime(evalue);                

                let sidx = valueList.indexOf(Vsvalue);
                let eidx = valueList.indexOf(Vevalue);

                if (sDate.getDate() != eDate.getDate() && evalue == '00:00:00') {
                    eidx = valueList.indexOf('24:00:00');
                }

                let max = 0;
                for (let dp = sidx; dp <= eidx; dp++) {
                    let num = duplicateCheckArray[i][dp];
                    if (max < num) {
                        max = num;
                    }
                }
                event.ui_week_maxcount = max;
            }

            for (let x = 0; x < daysEventList[i].length; x++) {
                const source = daysEventList[i][x];
                let smax = source.ui_week_maxcount;
                for (let y = 0; y < daysEventList[i].length; y++) {
                    const target = daysEventList[i][y];
                    if (x != y) {
                        if (dateutil.uGetInDateBoundary(
                            dateutil.IEDate(source.ui_week_start || source.start),
                            dateutil.IEDate(source.ui_week_end || source.end),
                            dateutil.IEDate(target.ui_week_start || target.start),
                            dateutil.IEDate(target.ui_week_end || target.end))) {
                            if (smax < target.ui_week_maxcount) {
                                source.ui_week_maxcount = target.ui_week_maxcount;
                            }
                        }
                    }
                }
            }
            let saveIndexArray:Array<Array<calendar.CalendarItem>> = [];
            for (let x = 0; x < daysEventList[i].length; x++) {
                const source = daysEventList[i][x];
                let calcIdx = 0;

                for (let y = 0; y < x; y++) {
                    let sStartNum = Number(dateutil.IEDate(source.ui_week_start || source.start));
                    if (saveIndexArray[y]) {
                        for (let s = 0; s < saveIndexArray[y].length; s++) {
                            const sevent = saveIndexArray[y][s];
                            let bStartNum = Number(dateutil.IEDate(sevent.ui_week_start || sevent.start));
                            let bEndNum = Number(dateutil.IEDate(sevent.ui_week_end || sevent.end));
                            if (sStartNum >= bStartNum && sStartNum < bEndNum) {
                                calcIdx++;
                            } 
                        }

                        if (calcIdx == y) {
                            break;
                        }
                    }                    
                }
                if (!saveIndexArray[calcIdx]) 
                {
                    saveIndexArray[calcIdx] = [];
                }                
                
                source.ui_week_ui_index = calcIdx;

                saveIndexArray[calcIdx].push(source);
            }
        }


        tidx = 0;

        for (const timeItem of timeList) {
            if (tidx > 48) break;
            let Rows = [];
            let titleDateItem: calendar.DateItem = Object.create(null);
            titleDateItem.ui_days_week_time_text = dateutil.uGetZero(timevalue) as string;
            Rows.push(titleDateItem);
            for (let i = 0; i < daysList.length; i++) {
                let oDate = daysList[i];
                let date = new Date(oDate);
                date = new Date(dateutil.uGetDateFormat('yyyy-MM-DD', date) + 'T' + timeItem.value); // Set Time

                let isToday =
                    date.getFullYear() == today.getFullYear() &&
                    date.getMonth() == today.getMonth() &&
                    date.getDate() == today.getDate();

                let isSelected =
                    date.getFullYear() == state.currentCalendarTime.date.getFullYear() &&
                    date.getMonth() == state.currentCalendarTime.date.getMonth() &&
                    date.getDate() == state.currentCalendarTime.date.getDate() &&
                    date.getHours() == state.currentCalendarTime.date.getHours() &&
                    date.getMinutes() == state.currentCalendarTime.date.getMinutes();

                let isDisplayArea = false;
                if (state.calendarMode == EnumCalendarViewType.Month) {
                    if (state.currentCalendarDate.date.getMonth() == date.getMonth()) {
                        isDisplayArea = true;
                    }
                }

                if (state.calendarMode == EnumCalendarViewType.Week) {
                    let weekStartDate = dateutil.uGetWeekStartDate(state.currentCalendarDate.date);
                    let weekEndDate = dateutil.uGetWeekEndDate(state.currentCalendarDate.date);

                    if (Number(weekStartDate) <= Number(date) && Number(weekEndDate) >= Number(date)) {
                        isDisplayArea = true;
                    }
                }

                if (state.calendarMode == EnumCalendarViewType.Daily) {
                    if (isSelected) {
                        isDisplayArea = true;
                    }
                }

                let curEvents = getContainsWeekEvents(i, date, copyEvents);

                for (let e = 0; e < curEvents.length; e++) {
                    const event = curEvents[e];
                    copyEvents.splice(event.index - e, 1);
                }

                let max = 0;
                for (let t = 0; t < curEvents.length; t++) {
                    const event = curEvents[t];
                    max = event.ui_week_maxcount;
                }

                let resultEvents = [];

                for (let c = 0; c < max; c++) {
                    let isAddedFlag = false;
                    for (let f = 0; f < curEvents.length; f++) {
                        const fevent = curEvents[f];
                        if (fevent.ui_week_ui_index == c) {
                            let copyEvent: calendar.CalendarItem = Object.create(null);
                            Object.assign(copyEvent, fevent);
                            addPrintEvent(state, copyEvent);
                            resultEvents.push(copyEvent);
                            isAddedFlag = true;
                            break;
                        }
                    }

                    if (!isAddedFlag) {
                        resultEvents.push({
                            id: 'null',
                            color: 'null',
                            organizer: {
                                name: null,
                            },
                        });
                    }
                }

                let dateItem = {
                    date: date,
                    isToday: isToday,
                    isSelected: isSelected,
                    isSun: date.getDay() == 0,
                    isSat: date.getDay() == 6,
                    isDisplayArea: isDisplayArea,
                    events: resultEvents,
                } as calendar.DateItem;

                Rows.push(dateItem);
            }
            let NewRows = new Array;
            NewRows = Object.assign(NewRows, Rows);
            matrix.push(NewRows);
            timevalue += 0.5;
            tidx++;
        }
        state.calendarDateMatrix = matrix;
    },

    [types.CALENDAR_VIEWMODE_CHANGE](state, viewType: EnumCalendarViewType) {
        state.calendarMode = viewType;
    },

    [types.CALENDAR_EVENT_ADD](state, data: calendar.CalendarItemContainer) {
        const { item } = data;
        state.newCalendar.item = item;
    },

    [types.CALENDAR_EVENT_EDIT](state, data: calendar.CalendarItemContainer) {
        const { item } = data;
        state.editCalendar.item = item;
    },

    [types.CALENDAR_DAILY_EVENT_LOAD_LIST](state, eventsList: ItemList<calendar.CalendarItem>) {
        state.calendarDailyEvents = eventsList;
        state.recursionFlags.CALENDAR_DAILY_EVENT_LOAD_LIST = 0;
    },

    [types.CALENDAR_EVENT_LOAD_LIST](state, eventsList: ItemList<calendar.CalendarItem>) {
        state.calendarEvents = eventsList;    
        state.calendarPrintEvents = [];
        state.recursionFlags.CALENDAR_EVENT_LOAD_LIST = 0;
    },

    [types.CALENDAR_SEARCH_LOAD](state, data: any) {
        state.searchEvents = data;
        Object.assign(state.calendarPrintEvents, data);
    },

    [types.CALENDAR_SEARCH_OPTION](state, data: any) {
        state.toolbar.search.Keyword = data;
    },

    [types.COMMON_ERROR_MESSAGE](state, errorMessage: string) {
        state.currentError = errorMessage;
    },

    [types.COMMON_ERROR_CLEAR](state) {
        state.currentError = '';
    },

    [types.CALENDAR_SHARED_SHOW](state, flag: boolean) {
        state.toolbar.showDetailShareOption = flag;
    },

    [types.CALENDAR_SEARCH_SHOW](state, flag: boolean) {
        state.toolbar.showDetailSearchOption = flag;
    },

    [types.CALENDAR_RECURRING_SHOW](state, flag: boolean) {
        state.showRecurringOption = flag;
    },

    [types.CALENDAR_CURRENT_RECURRING](state, data: any) {
        state.currentRecurringItem = data;
    },

    [types.CALENDAR_TODAY_MODE](state, data: any) {
        state.todayMode = data;
        console.log('mutt..')
    },

    [types.COMMON_TOGGLE_CONTENTMASK](state, flag: boolean) {
        state.showContentMask = flag;
    }
};


